const tokens = {
  colors: {
    bg: {
      default: 'white',
      _dark: 'brandGray.800',
    },
    bgSecondary: {
      default: 'brandGray.50',
      _dark: 'brandGray.750',
    },
    bgSelected: {
      default: 'blue.50',
      _dark: 'brandGray.750',
    },
    borderSelected: {
      default: 'blue.500',
      _dark: 'brandGray.600',
    },
    blue: {
      default: 'blue.200',
      _dark: 'blue.600',
    },
    divider: {
      default: 'brandGray.300',
      _dark: 'brandGray.700',
    },
    border: {
      default: 'brandGray.200',
      _dark: 'brandGray.700',
    },
    borderList: {
      default: 'brandGray.200',
      _dark: 'brandGray.900',
    },
    // same as the default body text color set in theme/styles but here JIC it's needed
    text: {
      default: 'black.700',
      _dark: 'white.900',
    },
    textSecondary: {
      default: 'brandGray.500',
    },
    icon: {
      default: 'brandGray.700',
      _dark: 'brandGray.400',
    },
    iconHover: {
      default: 'brandGray.900',
      _dark: 'brandGray.300',
    },
  },
}

export default tokens
